import { api } from '../../app/api/baseApi';
import {
    CreateSubscriptionV2Request,
    PaginatedSubscriptionsV2,
    SitePartNumberDetail,
    SubscriptionDetailV2,
    UpdateSubscriptionV2Request,
} from '../../types/subscription';

export const subscriptionV2Api = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getAllSubscriptionsV2: builder.query<{ data: PaginatedSubscriptionsV2 }, any>({
            query: ({ body, headers }) => {
                const bodyClone = JSON.parse(JSON.stringify(body));
                if (bodyClone.headers) delete bodyClone.headers;
                return {
                    url: 'es/v2/subscriptions/filter',
                    method: 'POST',
                    body: bodyClone,
                    ...(headers && { headers }),
                };
            },
            providesTags: ['allSubscriptionsV2'],
        }),
        getSubscriptionByIdV2: builder.query<{ data: SubscriptionDetailV2 }, string>({
            query: (id) => ({
                url: `es/v2/subscriptions/${id}`,
                method: 'GET',
            }),
            providesTags: ['subscriptionV2Details'],
        }),
        createSubscriptionV2: builder.mutation<
            any,
            { body: CreateSubscriptionV2Request; realmPrefix?: string; orgId?: string }
        >({
            query: ({ body, realmPrefix, orgId }) => ({
                url: 'es/v2/subscriptions',
                method: 'POST',
                body,
                headers: {
                    ...(realmPrefix && { 'x-realm': realmPrefix }),
                    ...(orgId && { organizationId: orgId }),
                },
            }),
            invalidatesTags: (result, error): any => (!error ? ['allSubscriptionsV2', 'allSubscriptions'] : []),
        }),
        updateSubscriptionV2: builder.mutation<
            void,
            { id: string; body: UpdateSubscriptionV2Request; realmPrefix?: string }
        >({
            query: ({ id, body, realmPrefix }) => ({
                url: `es/v2/subscriptions/${id}`,
                method: 'PATCH',
                body,
                ...(realmPrefix && { headers: { 'x-realm': realmPrefix } }),
            }),
            invalidatesTags: (result, error): any => (!error ? ['subscriptionV2Details', 'allSubscriptionsV2'] : []),
        }),
        verifyActivationId: builder.query<
            { data: SitePartNumberDetail },
            { activationId: string; realmPrefix?: string }
        >({
            query: ({ activationId, realmPrefix }) => ({
                url: `es/v2/subscriptions/activation-id/${activationId}`,
                method: 'GET',
                ...(realmPrefix && { headers: { 'x-realm': realmPrefix } }),
            }),
            keepUnusedDataFor: 0,
            extraOptions: 'no-toast',
        }),
    }),
});

export const {
    useGetAllSubscriptionsV2Query,
    useGetSubscriptionByIdV2Query,
    useCreateSubscriptionV2Mutation,
    useUpdateSubscriptionV2Mutation,
    useLazyVerifyActivationIdQuery,
} = subscriptionV2Api;
